import React, { useState, useMemo, useEffect, useRef } from "react";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
import api from "../../services/api";

import {
  CssBaseline,
  TextField,
  Link,
  Box,
  Typography,
  Paper,
  Button,
  InputAdornment,
  IconButton,
} from "@material-ui/core";

import {
  Visibility,
  VisibilityOff,
  Person,
  Email,
  Phone,
  Lock,
  Business,
  PersonAdd,
} from "@material-ui/icons";

import { makeStyles } from "@material-ui/core/styles";
import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import AuthCredit from "../../components/AuthCredit";
import AuthShowcase from "../../components/AuthShowcase";

/* ======================================================
   STYLES – EXACTAMENTE IGUALES AL LOGIN
====================================================== */
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "grid",
    gridTemplateColumns: "1fr",
    background:
      "radial-gradient(1200px 500px at 20% 10%, rgba(59,130,246,0.18), transparent 60%)," +
      "radial-gradient(900px 400px at 80% 30%, rgba(16,185,129,0.12), transparent 55%)," +
      "linear-gradient(180deg, #f7f9ff 0%, #edf2ff 100%)",
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr",
    },
    overflowX: "hidden",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    [theme.breakpoints.down("sm")]: {
      minHeight: "100dvh",
    },
  },

  left: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: theme.spacing(3),
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      alignItems: "stretch",
      padding: 0,
      margin: 0,
      width: "100%",
      minHeight: "100dvh",
      flex: 1,
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(6),
    },
  },

  formPaper: {
    width: "100%",
    maxWidth: 460,
    borderRadius: 18,
    padding: theme.spacing(3),
    boxShadow: "0 18px 60px rgba(15, 23, 42, 0.10)",
    border: "1px solid rgba(15,23,42,0.06)",
    background: "rgba(255,255,255,0.92)",
    backdropFilter: "blur(10px)",
    maxHeight: "calc(100vh - 96px)",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      width: "100%",
      minHeight: "100dvh",
      maxHeight: "none",
      borderRadius: 0,
      boxShadow: "none",
      border: "none",
      padding: theme.spacing(2, 2.5),
      paddingTop: "max(16px, env(safe-area-inset-top, 0px))",
      paddingBottom: "max(16px, env(safe-area-inset-bottom, 0px))",
      display: "flex",
      flexDirection: "column",
      background: "#ffffff",
      backdropFilter: "none",
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
    },
  },

  paperInner: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0,
      justifyContent: "center",
      width: "100%",
    },
  },

  formikWrap: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      flex: "0 0 auto",
      width: "100%",
    },
  },

  authForm: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      flex: "0 0 auto",
      width: "100%",
    },
  },

  title: {
    fontSize: 26,
    fontWeight: 900,
    color: "#0f172a",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: 22,
      marginBottom: theme.spacing(1.5),
    },
  },

  field: {
    marginBottom: 12,
    "& .MuiOutlinedInput-root": {
      minHeight: 46,
      borderRadius: 12,
      "& fieldset": { borderColor: "rgba(15,23,42,0.14)" },
      "&:hover fieldset": { borderColor: "rgba(15,23,42,0.25)" },
      "&.Mui-focused fieldset": { borderColor: "#2563eb" },
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 10,
      "& .MuiOutlinedInput-root": {
        minHeight: 52,
      },
    },
  },

  submit: {
    marginTop: 10,
    height: 46,
    borderRadius: 12,
    fontWeight: 900,
    background: "linear-gradient(45deg, #2563eb 30%, #1d4ed8 90%)",
    color: "#fff",
    "& .MuiButton-startIcon": { color: "#fff" },
    [theme.breakpoints.down("sm")]: {
      minHeight: 52,
      height: 52,
    },
  },

  loginLink: {
    color: "#2563eb",
    fontWeight: 800,
    textDecoration: "none",
  },

  /* ================= RIGHT PANEL – 100% IGUAL LOGIN ================= */

  right: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "grid",
      placeItems: "center",
      padding: theme.spacing(6),
      position: "relative",
    },
  },

  rightCanvas: {
    width: "100%",
    maxWidth: 720,
    height: 520,
    borderRadius: 28,
    position: "relative",
    overflow: "hidden",
    border: "1px solid rgba(15,23,42,0.08)",
    background: "rgba(255,255,255,0.55)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 18px 60px rgba(15, 23, 42, 0.10)",
  },

  blob1: {
    position: "absolute",
    width: 420,
    height: 420,
    left: -120,
    top: -140,
    borderRadius: "50%",
    background:
      "radial-gradient(circle at 30% 30%, rgba(37, 99, 235, 0.35), rgba(37, 99, 235, 0) 60%)",
    filter: "blur(6px)",
  },
  blob2: {
    position: "absolute",
    width: 460,
    height: 460,
    right: -180,
    bottom: -180,
    borderRadius: "50%",
    background:
      "radial-gradient(circle at 40% 40%, rgba(5, 150, 105, 0.28), rgba(5, 150, 105, 0) 62%)",
    filter: "blur(8px)",
  },
  blob3: {
    position: "absolute",
    width: 260,
    height: 260,
    right: 60,
    top: -80,
    borderRadius: "50%",
    background:
      "radial-gradient(circle at 50% 50%, rgba(99, 102, 241, 0.22), rgba(99, 102, 241, 0) 65%)",
    filter: "blur(10px)",
  },

  gridOverlay: {
    position: "absolute",
    inset: 0,
    backgroundImage:
      "linear-gradient(to right, rgba(15,23,42,0.05) 1px, transparent 1px)," +
      "linear-gradient(to bottom, rgba(15,23,42,0.05) 1px, transparent 1px)",
    backgroundSize: "42px 42px",
    opacity: 0.6,
    pointerEvents: "none",
  },

  badge: {
    position: "absolute",
    top: 22,
    left: 22,
    padding: "8px 12px",
    borderRadius: 999,
    background: "rgba(15,23,42,0.06)",
    border: "1px solid rgba(15,23,42,0.08)",
    fontSize: 12,
    fontWeight: 800,
  },

  bubble: {
    position: "absolute",
    padding: "12px 14px",
    borderRadius: 16,
    background: "rgba(255,255,255,0.78)",
    border: "1px solid rgba(15,23,42,0.08)",
    boxShadow: "0 10px 30px rgba(15,23,42,0.10)",
    display: "grid",
    gap: 6,
    minWidth: 180,
    opacity: 0,
    transform: "translateY(14px) scale(0.98)",
    animationName: "$bubbleIn",
    animationDuration: "700ms",
    animationTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)",
    animationFillMode: "forwards",
  },

  bubble1: { animationDelay: "120ms" },
  bubble2: { animationDelay: "320ms" },
  bubble3: { animationDelay: "520ms" },

  bubbleTitle: {
    fontSize: 12,
    fontWeight: 900,
    color: "rgba(15,23,42,0.75)",
    textTransform: "uppercase",
    display: "flex",
    justifyContent: "space-between",
  },

  dot: {
    width: 8,
    height: 8,
    borderRadius: 999,
    background: "rgba(37, 99, 235, 0.65)",
  },

  bubbleLine: {
    height: 10,
    borderRadius: 999,
    background: "rgba(15,23,42,0.08)",
  },

  "@keyframes bubbleIn": {
    from: { opacity: 0, transform: "translateY(14px) scale(0.98)" },
    to: { opacity: 1, transform: "translateY(0) scale(1)" },
  },
}));

/* ======================================================
   VALIDATION
====================================================== */
const required = "Este dato es obligatorio";
const UserSchema = Yup.object().shape({
  companyName: Yup.string().trim().min(2, "Escribe al menos 2 caracteres").required(required),
  name: Yup.string().trim().min(2, "Escribe al menos 2 caracteres").required(required),
  email: Yup.string().trim().email("Escribe un correo válido, por ejemplo nombre@correo.com").required(required),
  phone: Yup.string()
    .trim()
    .required(required)
    .test(
      "country-code",
      "Escribe el WhatsApp con indicativo, sin el 0 inicial. Ejemplo: 51987654321",
      (value) => {
        const digits = String(value || "").replace(/\D/g, "");
        return digits.length >= 11 && digits.length <= 15 && !digits.startsWith("0");
      }
    ),
  password: Yup.string().min(8, "Mínimo 8 caracteres").required("La contraseña es obligatoria"),
});

/* ======================================================
   COMPONENT
====================================================== */
const SignUp = () => {
  const classes = useStyles();
  const history = useHistory();
  const isMounted = useRef(true);
  const [showPassword, setShowPassword] = useState(false);
  const [pendingEmail, setPendingEmail] = useState("");
  const [trial, setTrial] = useState(1); // ✅ Valor por defecto: 1 día
  // Enlace de un plan WaToolX ya pagado (?activar=…): la cuenta nace con el plan activo.
  const location = useLocation();
  const activationToken = useMemo(() => new URLSearchParams(location.search).get("activar") || "", [location.search]);
  const [activation, setActivation] = useState(null);
  const [activated, setActivated] = useState(null);

  const dueDate = useMemo(
    () => moment().add(trial, "day").format(),
    [trial]
  );

  // ✅ Verificar si el registro está habilitado usando endpoint público que verifica AMBAS configuraciones
  // ✅ También obtiene el valor dinámico de trial (días de prueba)
  useEffect(() => {
    isMounted.current = true;

    const checkRegistrationEnabled = async () => {
      if (activationToken) {
        try {
          const { data } = await openApi.get(`/watoolx-activation/${encodeURIComponent(activationToken)}`);
          if (!isMounted.current) return;
          if (data.status === "used" || data.kind !== "watoolx") { history.push(`/activar-plan/${activationToken}`); return; }
          setActivation(data);
          return;
        } catch (error) {
          if (!isMounted.current) return;
          toastError(error);
          history.push("/login");
          return;
        }
      }
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        const response = await api.get("/settings/registration-status", {
          signal: controller.signal,
        });

        clearTimeout(timeoutId);
        if (!isMounted.current) return;

        // ✅ El registro debe estar habilitado si AMBAS configuraciones están en "enabled"
        const registrationEnabled = response?.data?.enabled === true;
        if (!registrationEnabled) {
          // Redirigir al login si el registro está deshabilitado
          history.push("/login");
          return;
        }

        // ✅ Obtener días de prueba desde la configuración (valor dinámico)
        const trialDays = response?.data?.trial || 1;
        if (trialDays && !isNaN(parseInt(trialDays, 10)) && parseInt(trialDays, 10) > 0) {
          setTrial(parseInt(trialDays, 10));
        }
      } catch (error) {
        if (!isMounted.current) return;
        // Si hay error, redirigir al login por seguridad
        history.push("/login");
      }
    };

    checkRegistrationEnabled();

    return () => {
      isMounted.current = false;
    };
  }, [history, activationToken]);

  const handleSubmit = async (values) => {
    try {
      // El backend asigna el plan de prueba con todas las funciones; la duración se controla en el servidor.
      const { data } = await openApi.post("/companies/cadastro", {
        ...(activation ? { activationToken } : {}),
        name: values.companyName,
        ownerName: values.name,
        phone: values.phone,
        email: values.email,
        password: values.password,
        recurrence: "MENSAL",
        dueDate,
        status: true,
        campaignsEnabled: true,
      });
      if (data?.activation) setActivated(data.activation);
      else if (activation && data?.activationError) toastError(`Tu cuenta se creó, pero el plan no se activó: ${data.activationError}. Escríbenos por el chat y lo activamos.`);
      setPendingEmail(values.email);
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* IZQUIERDA */}
      <div className={classes.left}>
        <Paper className={classes.formPaper}>
          <div className={classes.paperInner}>
          <Typography className={classes.title}>{activation ? "Activa tu plan" : "Crear cuenta"}</Typography>
          {activation && !pendingEmail && (
            <Box style={{ background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 12, padding: "12px 14px", marginBottom: 16 }}>
              <Typography style={{ color: "#065f46", fontWeight: 700 }}>
                ✅ Plan {activation.plan?.name} pagado
              </Typography>
              <Typography variant="body2" style={{ color: "#047857", lineHeight: 1.5 }}>
                {activation.plan?.users} usuarios · {activation.plan?.connections} líneas · {activation.months} {activation.months === 1 ? "mes" : "meses"}.
                Crea tu cuenta y el plan queda activo de una vez (pedido #{activation.orderId}).
              </Typography>
              <Link component={RouterLink} to={`/activar-plan/${activationToken}`} className={classes.loginLink} style={{ fontSize: 13 }}>
                ¿Ya tienes cuenta WaToolX? Actívalo en ella
              </Link>
            </Box>
          )}

          {pendingEmail ? (
            <Box>
              <Typography style={{ color: "#0f172a", fontWeight: 700, marginBottom: 8 }}>
                Revisa tu correo
              </Typography>
              {activated && (
                <Box style={{ background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 12, padding: "12px 14px", marginBottom: 12 }}>
                  <Typography style={{ color: "#065f46", fontWeight: 700 }}>
                    ✅ Plan {activated.plan} activo hasta el {activated.dueLabel}
                  </Typography>
                </Box>
              )}
              <Typography variant="body2" style={{ color: "#475569", lineHeight: 1.5, marginBottom: 16 }}>
                Enviamos un enlace de confirmación a {pendingEmail}. Cuando lo confirmes podrás iniciar sesión.
                Después te pediremos validar el WhatsApp.
              </Typography>
              <Link component={RouterLink} to="/login" className={classes.loginLink}>
                Ir a iniciar sesión
              </Link>
              <Box mt={3}>
                <AuthCredit />
              </Box>
            </Box>
          ) : (
          <div className={classes.formikWrap}>
          <Formik
            initialValues={{
              companyName: "",
              name: "",
              email: "",
              phone: "",
              password: "",
            }}
            validationSchema={UserSchema}
            onSubmit={handleSubmit}
          >
            {({ handleChange, handleBlur, errors, touched }) => (
              <Form className={classes.authForm}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Empresa"
                  name="companyName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.companyName && Boolean(errors.companyName)}
                  helperText={touched.companyName && errors.companyName}
                  className={classes.field}
                  InputProps={{ startAdornment: <InputAdornment position="start"><Business /></InputAdornment> }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  label="Nombre"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                  className={classes.field}
                  InputProps={{ startAdornment: <InputAdornment position="start"><Person /></InputAdornment> }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  label="Correo electrónico"
                  name="email"
                  type="email"
                  autoComplete="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                  className={classes.field}
                  InputProps={{ startAdornment: <InputAdornment position="start"><Email /></InputAdornment> }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  label="WhatsApp"
                  name="phone"
                  inputMode="tel"
                  autoComplete="tel"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.phone && Boolean(errors.phone)}
                  helperText={touched.phone && errors.phone ? errors.phone : "Con indicativo. Ejemplo: 51987654321"}
                  placeholder="51987654321"
                  className={classes.field}
                  InputProps={{ startAdornment: <InputAdornment position="start"><Phone /></InputAdornment> }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  label="Contraseña"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="new-password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.password && Boolean(errors.password)}
                  helperText={
                    touched.password && errors.password
                      ? errors.password
                      : "Mínimo 8 caracteres"
                  }
                  className={classes.field}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><Lock /></InputAdornment>,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="mostrar u ocultar contraseña"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button type="submit" fullWidth className={classes.submit} startIcon={<PersonAdd />}>
                  {activation ? "Crear cuenta y activar plan" : "Crear cuenta gratuita"}
                </Button>

                <Box mt={2} textAlign="center">
                  <Typography variant="body2">
                    ¿Ya tienes cuenta?{" "}
                    <Link component={RouterLink} to="/login" className={classes.loginLink}>
                      Inicia sesión
                    </Link>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <AuthCredit />
                </Box>
              </Form>
            )}
          </Formik>
          </div>
          )}
          </div>
        </Paper>
      </div>

      {/* DERECHA – EXACTAMENTE IGUAL AL LOGIN */}
      <div className={classes.right}>
        <div className={classes.rightCanvas}>
          <div className={classes.blob1} />
          <div className={classes.blob2} />
          <div className={classes.blob3} />
          <div className={classes.gridOverlay} />

          <AuthShowcase />
        </div>
      </div>
    </div>
  );
};

export default SignUp;
